/**
 * Ошибка API с кодом сервера (`error.code` обёртки {success, data, error}) и HTTP-статусом.
 * Отдельным модулем: её бросают и клиент ядра, и вход мини-аппа (без тостов и рантайма).
 */
export class ApiError extends Error {
  constructor(
    message: string,
    public code: string,
    public status?: number
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
